<div class="complaint-dialog-shell" [ngStyle]="{'--complaint-color': uiData.complaint.color}">
  <ng-container *ngIf="!submitted; else successState">
    <mat-card class="complaint-dialog-header" [style.background-color]="uiData.complaint.color">
      <mat-card-title>
        <mat-icon>{{ uiData.complaint.icon }}</mat-icon>
        Complaint Submission
      </mat-card-title>
      <div class="complaint-dialog-subtitle">
        Report a lead-based paint concern to the Oregon Lead-Based Paint Program. Submitter information is optional.
      </div>
    </mat-card>

    <div class="complaint-dialog-body">
      <mat-card class="complaint-intro-card">
        <div class="complaint-intro-kicker">Anonymous reporting available</div>
        <div class="complaint-intro-copy">
          Leave the submitter section blank if you do not want to identify yourself. Complaints may be subject to public disclosure under Oregon Public Records Law.
        </div>
      </mat-card>

      <form [formGroup]="complaintForm" class="complaint-form">
        <div class="complaint-form-grid">
          <mat-card class="complaint-section">
            <mat-card-title>Optional Submitter Information</mat-card-title>
            <mat-card-subtitle>Use these fields only if you want follow-up from staff.</mat-card-subtitle>

            <div class="two-column-grid">
              <mat-form-field>
                <mat-label>First Name</mat-label>
                <input matInput formControlName="submitterFirstName" aria-label="Submitter first name">
              </mat-form-field>

              <mat-form-field>
                <mat-label>Last Name</mat-label>
                <input matInput formControlName="submitterLastName" aria-label="Submitter last name">
              </mat-form-field>
            </div>

            <div class="two-column-grid">
              <mat-form-field>
                <mat-label>Phone Number</mat-label>
                <input matInput formControlName="submitterPhone" aria-label="Submitter phone number">
                <mat-error *ngIf="complaintForm.get('submitterPhone')?.hasError('pattern')">Enter a valid phone number.</mat-error>
              </mat-form-field>

              <mat-form-field>
                <mat-label>Email Address</mat-label>
                <input matInput formControlName="submitterEmail" aria-label="Submitter email address">
                <mat-error *ngIf="complaintForm.get('submitterEmail')?.hasError('email')">Enter a valid email address.</mat-error>
              </mat-form-field>
            </div>

            <mat-form-field class="full-width-field">
              <mat-label>Street Address</mat-label>
              <input matInput formControlName="submitterAddressStreet" aria-label="Submitter street address">
            </mat-form-field>

            <div class="address-grid-secondary">
              <mat-form-field>
                <mat-label>City</mat-label>
                <input matInput formControlName="submitterAddressCity" aria-label="Submitter city">
              </mat-form-field>

              <mat-form-field>
                <mat-label>State</mat-label>
                <mat-select formControlName="submitterAddressState" aria-label="Submitter state">
                  <mat-option value="">Select State</mat-option>
                  <mat-option *ngFor="let state of sharedService.states" [value]="state">{{ state }}</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field>
                <mat-label>ZIP</mat-label>
                <input matInput formControlName="submitterAddressZip" aria-label="Submitter zip code">
                <mat-error *ngIf="complaintForm.get('submitterAddressZip')?.hasError('pattern')">Enter a valid ZIP code.</mat-error>
              </mat-form-field>
            </div>
          </mat-card>

          <mat-card class="complaint-section complaint-section-primary">
            <mat-card-title>Complaint Location</mat-card-title>
            <mat-card-subtitle>Tell us where the reported activity occurred.</mat-card-subtitle>

            <mat-form-field class="full-width-field">
              <mat-label>Street Address</mat-label>
              <input matInput formControlName="locationStreet" aria-label="Complaint location street address">
              <mat-error *ngIf="complaintForm.get('locationStreet')?.hasError('required')">Street address is required.</mat-error>
            </mat-form-field>

            <div class="location-grid-secondary">
              <mat-form-field>
                <mat-label>City</mat-label>
                <input matInput formControlName="locationCity" aria-label="Complaint location city">
                <mat-error *ngIf="complaintForm.get('locationCity')?.hasError('required')">City is required.</mat-error>
              </mat-form-field>

              <mat-form-field>
                <mat-label>State</mat-label>
                <mat-select formControlName="locationState" aria-label="Complaint location state" (selectionChange)="onLocationStateChanged()">
                  <mat-option *ngFor="let state of sharedService.states" [value]="state">{{ state }}</mat-option>
                </mat-select>
                <mat-error *ngIf="complaintForm.get('locationState')?.hasError('required')">State is required.</mat-error>
              </mat-form-field>

              <mat-form-field>
                <mat-label>ZIP</mat-label>
                <input matInput formControlName="locationZip" aria-label="Complaint location zip code">
                <mat-error *ngIf="complaintForm.get('locationZip')?.hasError('pattern')">Enter a valid ZIP code.</mat-error>
              </mat-form-field>
            </div>

            <mat-form-field *ngIf="showLocationCounty" class="full-width-field">
              <mat-label>County</mat-label>
              <mat-select formControlName="locationCounty" aria-label="Complaint location county">
                <mat-option value="">Select County</mat-option>
                <mat-option *ngFor="let county of sharedService.counties" [value]="county">{{ county }}</mat-option>
              </mat-select>
            </mat-form-field>
          </mat-card>
        </div>

        <mat-card class="complaint-section">
          <mat-card-title>People Involved</mat-card-title>
          <mat-card-subtitle>List names or identifying details if you know them.</mat-card-subtitle>

          <mat-form-field class="full-width-field">
            <mat-label>Names of Individuals Involved</mat-label>
            <textarea matInput rows="3" formControlName="peopleInvolved" aria-label="Names of individuals involved"></textarea>
          </mat-form-field>
        </mat-card>

        <mat-card class="complaint-section complaint-section-primary complaint-narrative-section">
          <mat-card-title>Complaint Narrative</mat-card-title>
          <mat-card-subtitle>Describe what happened, when it happened, and anything else investigators should know.</mat-card-subtitle>

          <mat-form-field class="full-width-field">
            <mat-label>What happened?</mat-label>
            <textarea matInput rows="8" formControlName="narrative" aria-label="Complaint narrative"></textarea>
            <mat-error *ngIf="complaintForm.get('narrative')?.hasError('required')">A complaint description is required.</mat-error>
          </mat-form-field>
        </mat-card>
      </form>
    </div>

    <mat-card class="complaint-dialog-actions">
      <button mat-stroked-button type="button" (click)="cancel()" [disabled]="submitting">Cancel</button>
      <button mat-raised-button color="primary" type="button" (click)="submit()" [disabled]="submitting">
        {{ submitting ? 'Submitting...' : 'Submit Complaint' }}
      </button>
    </mat-card>
  </ng-container>

  <ng-template #successState>
    <mat-card class="complaint-dialog-header" [style.background-color]="uiData.complaint.color">
      <mat-card-title>
        <mat-icon>task_alt</mat-icon>
        Complaint Received
      </mat-card-title>
      <div class="complaint-dialog-subtitle">
        Your complaint has been submitted for review by the Oregon Lead-Based Paint Program.
      </div>
    </mat-card>

    <div class="complaint-dialog-body complaint-dialog-success-body">
      <mat-card class="complaint-success-card">
        <div class="complaint-success-kicker">Reference Number</div>
        <div class="complaint-success-number">{{ receipt?.id || 'Pending' }}</div>
        <p>
          Keep this number for your records. Staff may follow up if you provided contact information and additional details are needed.
        </p>
      </mat-card>
    </div>

    <mat-card class="complaint-dialog-actions">
      <button mat-raised-button color="primary" type="button" (click)="closeAfterSuccess()">Close</button>
    </mat-card>
  </ng-template>
</div>